var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocxThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.065 25H65.5987C61.5862 25 58.332 28.2542 58.332 32.2667V62.5125H183.332V32.2667C183.332 28.2542 180.078 25 176.065 25Z",
    fill: "#2D92D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.332 137.725V167.733C58.332 171.745 61.5862 175 65.5945 175H176.065C180.078 175 183.332 171.745 183.332 167.733V137.725H58.332Z",
    fill: "#2150A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.332 62.5117H183.332V100.02H58.332V62.5117Z",
    fill: "#2D83D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.332 100.021H183.332V137.73H58.332V100.021Z",
    fill: "#2E70C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9971 141.667H23.6721C19.8055 141.667 16.668 138.53 16.668 134.663V65.3381C16.668 61.4715 19.8055 58.334 23.6721 58.334H92.9971C96.8638 58.334 100.001 61.4715 100.001 65.3381V134.663C100.001 138.53 96.8638 141.667 92.9971 141.667Z",
    fill: "#00488D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6776 79.166L70.2359 109.433L63.0984 79.166H53.9859L46.6234 110.37L39.9859 79.166H31.8359L41.6026 120.833H51.4026L58.5401 88.7952L65.6818 120.833H75.0609L84.8276 79.166H76.6776Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocxThumbnail);
export default __webpack_public_path__ + "static/media/docx-thumbnail.34847a5634ae1709c3755c82cabcddfa.svg";
export { ForwardRef as ReactComponent };